import { CommerceHubEarlyAdopterBanner } from 'pricing-pages-ui-components/banners/CommerceHubEarlyAdopterBanner';
import Raven from 'raven-js';
import { useEffect } from 'react';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
import { useCommerceHubEarlyAdopterBanner } from '../../v2/hooks/banners/useCommerceHubEarlyAdopterBanner';
import { trackBannerInteraction } from '../../v2/utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const CommerceHubEarlyAdopterBannerWrapper = () => {
  const currencyCode = useDisplayedCurrencyCode();
  const {
    shouldShowBanner,
    error,
    professionalPrice,
    enterprisePrice,
    professionalNonDiscountedPrice,
    enterpriseNonDiscountedPrice
  } = useCommerceHubEarlyAdopterBanner();
  useEffect(() => {
    if (error) {
      Raven.captureException(error);
    }
  }, [error]);
  if (!shouldShowBanner || !professionalPrice || !enterprisePrice || !professionalNonDiscountedPrice || !enterpriseNonDiscountedPrice) {
    return null;
  }
  return /*#__PURE__*/_jsx(CommerceHubEarlyAdopterBanner, {
    professionalPrice: professionalPrice,
    enterprisePrice: enterprisePrice,
    professionalNonDiscountedPrice: professionalNonDiscountedPrice,
    enterpriseNonDiscountedPrice: enterpriseNonDiscountedPrice,
    currencyCode: currencyCode,
    trackBannerInteraction: trackBannerInteraction
  });
};
export default CommerceHubEarlyAdopterBannerWrapper;